<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="components-preview wide-md mx-auto">
                    <div class="nk-block-head nk-block-head-lg wide-sm">
                        <div class="nk-block-head-content">
                            <h4 class="nk-block-title fw-normal">New Email</h4>
                        </div>
                    </div>
                    <div class="nk-block nk-block-lg">
                        <div class="card">
                            <div class="card-inner">
                                <div class="preview-block">
                                    <div class="row gy-4">
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-01">Subject</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="newTicket.subject" type="text" class="form-control" id="default-01">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-01">User</label>
                                                <div class="form-control-wrap">
                                                    <userdropdown v-model="userId" />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div class="form-group">
                                                <label class="form-label">Description</label>
                                                <div class="form-control-wrap">
                                                    <textarea v-model="newTicket.description" class="form-control no-resize"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <hr class="preview-hr">
                                    <div class="row gy-4 ">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                                            <button v-bind:disabled="$v.$invalid" v-on:click="SaveNewUser()" class="btn btn-primary" style="margin-right: 10px;"> Send</button>
                                            <a href="javascript:void(0)" v-on:click="GoToList()" class="btn btn-danger"> Cancel</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators';
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default ({
        components: {
            Loading
        },
        name: 'newTicket',
        data: function () {
            return {
                loading: false,
                userId: '',
                newTicket: {
                    id: '00000000-0000-0000-0000-000000000000',
                    description: '',
                    subject: '',
                    priority: 'Medium'
                }
            }
        },
        validations: {
            newTicket:
            {
                subject:
                {
                    required
                },
                description:
                {
                    required
                }
            }
        },

        methods: {
            GoToList: function () {
                this.$router.push('/Emails')
            },
            SaveNewUser: function () {
                var root = this;
                this.loading = true;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.post('/Support/SendEmailNotification?userId=' + this.userId, this.newTicket, { headers: { "Authorization": `Bearer ${token}` } });
                this.loading = false;
                root.$swal({
                    title: 'Sent!',
                    text: 'Email Sent Successfully!',
                    type: 'success',
                    icon: 'success',
                    confirmButtonClass: "btn btn-success",
                    buttonsStyling: false
                }).then(function (result) {
                    if (result) {
                        root.GoToList();
                    }
                });
            },



        },
        created: function () {

        },
    })
</script>
